export enum RateAmountType {
  PERCENTAGE = 'Percentage',
  VALUE = 'Value',
}
